module.exports = __webpack_public_path__ + "media/images/general/not_setting_thumb_1920_820-91fa82ae5135332fcc566f4ac24f142f.png";